// Accent,Essense,Bright,Ikkat,Cipher
//HB-7
import Carousel from '@common/components/Carousel';
import { getFilteredSliderImages } from '@common/models/Slider';
import { SliderSliceType } from '@common/store/slider/slice';
import { isBrowser, isMobile } from '@common/utils';
import SliderCta from '@components/SliderCta';
import LChevronRight from '@images/LChevronRight.svg';
import AspectRatio from '@lib/AspectRatio';
import Image from '@lib/Image';
import { LAYOUT_CONFIG } from '@theme/utils/constants';
import classnames from 'classnames';
import React, { useState } from 'react';

export interface BannerCarousalProps {
  slider: SliderSliceType;
}
interface Component {
  tag: React.ElementType;
  attributes: React.AllHTMLAttributes<T>;
}

const BannerCarousal: React.FC<BannerCarousalProps> = ({ slider }) => {
  const MOBILE_ASPECT_RATIO = 414 / 375;
  const DESKTOP_ASPECT_RATIO = 1440 / 650;
  const filteredImages = getFilteredSliderImages({ slider, shouldImageBePresent: true });
  const [key, setKey] = useState(0);
  const [hover, setHover] = useState(false);
  if (isBrowser()) {
    window.onresize = () => {
      setKey(key + 1);
    };
  }

  if (!filteredImages?.length) {
    return null;
  }
  return (
    <>
      <div
        className={classnames(
          'slider-5 container full-width-in-cipher-anchor px-0 mx-auto md:justify-center relative',
          {
            'slider-5 slider ': filteredImages.length,
            ' hidden': !filteredImages.length,
          },
        )}
        key={key}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <AspectRatio
          aspectRatio={
            LAYOUT_CONFIG?.slider?.aspectRatio
              ? LAYOUT_CONFIG?.slider?.aspectRatio
              : isMobile()
              ? MOBILE_ASPECT_RATIO
              : DESKTOP_ASPECT_RATIO
          }
        >
          <Carousel
            autoPlay={hover ? null : 5000}
            arrowLeft={
              filteredImages?.length > 1 ? (
                <div className="rounded-full hidden md:flex cursor-pointer justify-center h-full items-center ml-40">
                  <img src={LChevronRight} alt="Left" className={classnames('', {})} />
                </div>
              ) : null
            }
            arrowRight={
              filteredImages?.length > 1 ? (
                <div className="rounded-full hidden md:flex cursor-pointer justify-center h-full items-center mr-40">
                  <img src={LChevronRight} alt="Right" className={classnames(' transform rotate-180', {})} />
                </div>
              ) : null
            }
            arrowLeftDisabled={<></>}
            arrowRightDisabled={<></>}
            slides={filteredImages.map((banner, index) => {
              const Component: Component = {
                tag: banner.link && LAYOUT_CONFIG?.slider?.showCtaBtn === false ? 'a' : 'div',
                attributes:
                  banner.link && LAYOUT_CONFIG?.slider?.showCtaBtn === false
                    ? { href: banner.link, rel: 'noreferrer' }
                    : {},
              };
              return (
                <Component.tag
                  className="bg-cover bg-no-repeat w-full overflow-hidden relative"
                  key={banner.slider}
                  {...Component.attributes}
                >
                  <AspectRatio
                    key={banner.slider}
                    aspectRatio={
                      LAYOUT_CONFIG?.slider?.aspectRatio
                        ? LAYOUT_CONFIG?.slider?.aspectRatio
                        : isMobile()
                        ? MOBILE_ASPECT_RATIO
                        : DESKTOP_ASPECT_RATIO
                    }
                  >
                    <Image
                      src={filteredImages[index]?.image}
                      className="object-cover"
                      alt={`Hero Banner ${index + 1}`}
                      noDefaultFit
                      isEager={index === 0}
                    />
                    <div
                      className={classnames(
                        'px-40 md:px-0 h-full absolute top-0 w-full flex justify-center items-center flex-col',
                        {
                          'bg-slider-overlay': banner.heading || banner.subheading,
                        },
                      )}
                    >
                      {banner.showCustomText ? (
                        <>
                          <div
                            className="mx-auto text-slider-text text-38 md:text-65 mb-12 md:mb-24 font-bold leading-42 md:leading-70 w-full md:w-1024 text-center"
                            font-customisation="section-heading"
                            color-customisation="banner-heading"
                          >
                            {banner.heading}
                          </div>
                          <div
                            className="md:hidden mx-auto text-slider-text text-14 md:text-20 mb-30 leading-24 md:leading-28 font-normal w-full md:w-1024 text-center"
                            font-customisation="para-text"
                            color-customisation="banner-subHeading"
                          >
                            {banner.subheading?.length > 100
                              ? banner.subheading.substring(0, 100) + '...'
                              : banner.subheading}
                          </div>
                          <div
                            className="hidden mx-auto md:block text-slider-text text-18 mb-40 leading-24 md:leading-25 font-normal text-center md:w-1024 "
                            font-customisation="para-text"
                            color-customisation="banner-subHeading"
                          >
                            {banner.subheading}
                          </div>
                        </>
                      ) : null}

                      {banner.link && banner.showButton && LAYOUT_CONFIG?.slider?.showCtaBtn !== false ? (
                        <SliderCta link={banner.link} text={banner.label} />
                      ) : null}
                    </div>
                  </AspectRatio>
                </Component.tag>
              );
            })}
          ></Carousel>
        </AspectRatio>
      </div>
    </>
  );
};

export default BannerCarousal;
